import React from 'react';

import { BookingContext } from '@app/components/Pages/Booking/Booking';

interface EndSessionScreenProps {
	text: React.ReactNode;
}

const EndSessionScreen: React.FC<EndSessionScreenProps> = ({ text }) => {
	const context = React.useContext(BookingContext);

	if (!context?.state) throw new Error('Error context');

	const {
		action: { setErrorCode, setItem },
	} = context;

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					{text}
					<button
						className="btn btn-md btn-primary link"
						onClick={() => {
							setItem(undefined);
							setErrorCode(null);
						}}
					>
						Start over
					</button>
				</div>
			</div>
		</div>
	);
};

export default EndSessionScreen;
